module.exports = __webpack_public_path__ + "static/media/13_tn.b04e863b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/13_tn.jpg
// module id = 443
// module chunks = 0